import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useOneTimeDiscounts } from '../../hooks/useBilling';
import type { ChargeDetail } from '../../services/billing';
import { formatMoneyDollars } from '../../utils/money';
import { summarizeUsableCredits, usableCreditsParams } from './usableCredits';

interface UnusedCreditsWarningProps {
    charge: ChargeDetail;
    action: string;
}

export function UnusedCreditsWarning({ charge, action }: UnusedCreditsWarningProps) {
    const isPending = charge.status === 'pending';
    const { meta } = useOneTimeDiscounts(usableCreditsParams(charge), isPending);
    const { count, total } = summarizeUsableCredits(meta.statusSummary);

    if (!isPending || count === 0) return null;
    return (
        <div className="flex items-start gap-2.5 p-3 rounded-lg border border-amber-300 bg-amber-50 text-amber-900">
            <ExclamationTriangleIcon className="h-4 w-4 shrink-0 mt-0.5 text-amber-700" />
            <p className="text-sm">
                <span className="font-semibold">
                    {count} unused credit{count !== 1 ? 's' : ''} ({formatMoneyDollars(total)})
                </span>{' '}
                available for {charge.patientId ? 'this patient or practice' : 'this practice'}.{' '}
                {action}
            </p>
        </div>
    );
}
